var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MoreShapes } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Mounted } from "apparatus/library/physics/electric/mounted/utils";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let Capacitor = class Capacitor {
    render(appearance) {
        const { graphic } = renderCapacitor(appearance);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [
                { type: "wire", at: P(7, 50) },
                { type: "wire", at: P(-7, 50) },
            ]
        };
    }
};
Capacitor.properties = {
    label: "Capacitor",
    defaultAppearance: {},
    appearanceSpecs: [],
};
Capacitor = __decorate([
    staticImplements()
], Capacitor);
export { Capacitor };
let MountedCapacitor = class MountedCapacitor {
    render(appearance) {
        const { graphic: capacitor } = renderCapacitor(appearance);
        const { base, jacks, snaps } = Mounted.renderPlate({ appearance, height: 40, width: 70 });
        const graphic = new Group([base, capacitor, jacks]);
        capacitor.bounds.bottomCenter = P(35, 16);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [
                ...snaps
            ]
        };
    }
};
MountedCapacitor.properties = {
    label: "Capacitor",
    defaultAppearance: Object.assign(Object.assign({}, Capacitor.properties.defaultAppearance), Mounted.defaultAppearance),
    appearanceSpecs: [
        ...Capacitor.properties.appearanceSpecs,
        ...Mounted.appearanceSpecs
    ],
};
MountedCapacitor = __decorate([
    staticImplements()
], MountedCapacitor);
export { MountedCapacitor };
function renderCapacitor(appearance) {
    const diameter = 20;
    const height = 32;
    let { body, top, outline } = MoreShapes.cylinder3d({ diameter, height });
    body.withGradientFill("right", Gradients.cylinder("#444444".color()));
    top.withFill("#444444");
    outline.withStroke("default");
    const capDiameter = diameter - 8;
    const cap = new Path.Ellipse(R(0, 0, capDiameter, capDiameter / 2, Pivot.CENTER))
        .withPosition(top.position);
    cap.withFill("#bbbbbb");
    const shade = new Path(Segments([[-diameter / 2, height / 2 - 6], , [0, diameter * 0.3]])).mirrorX().withStroke(2.0, "#ffffff40");
    shade.strokeCap = "round";
    const shade2 = shade.clone();
    shade.withPositionDelta({ y: -2 }).withStroke(2.0, "#00000040");
    // Combine and add legs
    const graphic = new Group([
        new Path.Line(P(3, 8), P(7, 50)).withStroke("default"),
        new Path.Line(P(-3, 8), P(-7, 50)).withStroke("default"),
        body, top, cap, outline, shade2, shade
    ]);
    return { graphic };
}
